/*
 * @Author: Teemo Ding
 * @Date: 2022-02-28 15:28:37
 * @LastEditTime: 2023-03-14 15:34:54
 * @LastEditors: Jack Deng
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/EditFapiaoInfo/index.tsx
 */
import { Form } from 'antd';
import { getI18nFromGeneral } from '@/src/tools/tools';
import React, { Fragment } from 'react';
import {
  Input,
  ModalFooter,
  OriCheckbox,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import { InvoiceType } from 'src/types/common/invoice';
import { modal } from 'src/utils/Modal';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const OriCheckboxGroup = OriCheckbox.Group;

const EditFapiaoInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const hasBeenList = [
    {
      label: getI18n(
        `allOrders.orderDetail.component_customer_Fapiao_generated`,
      ),
      value: 'beenGenerated',
    },
    {
      label: getI18n(
        'allOrders.createneworder.component_customer_Fapiao_delivered',
      ),
      value: 'beenDelivered',
    },
  ];
  const {
    type,
    onConfirm,
    onDelete,
    onCancel: onPropsCancel,
    onDiscard,
    uuid,
    formRef,
    beenDelivered = false,
    beenGenerated = false,
  } = props;
  const hasBeen = Object.keys({
    ...(beenDelivered && { beenDelivered }),
    ...(beenGenerated && { beenGenerated }),
  });
  const requestCallback = (res) => {
    const { response, cb } = res || {};
    if (response) {
      if (cb) {
        cb();
      }
      return;
    }
  };
  const onFinish = (values) => {
    values.beenDelivered = values.hasBeen.includes('beenDelivered');
    values.beenGenerated = values.hasBeen.includes('beenGenerated');
    values.uuid = uuid;
    if (onConfirm) {
      onConfirm(values).then((res) => requestCallback(res));
    }
  };
  const onCancel = () => {
    if (onDelete) {
      modal.error({
        title: getI18n(
          'allOrders.createneworder.component_customer_editfapiaoinfo_cancelfapiao',
        ),
        content: getI18n(
          'allOrders.createneworder.component_customer_editfapiaoinfo_cancelfapiao_content',
        ),
        onOkText: getI18n('general.confirm'),
        onOk: () => {
          onDelete().then((res) => requestCallback(res));
        },
        onCancelText: getI18nFromGeneral('general.commonHeader.discard_text'),
        onCancel: () => void 0,
      });
    }
  };

  return (
    <Fragment>
      <Form
        className={css.editFapiaoInfo}
        name='editFapiaoInfo'
        form={formRef}
        onFinish={onFinish}>
        <Form.Item
          name='type'
          label={getI18n(
            'allOrders.createneworder.component_customer_editfapiaoinfo_fapiaotype',
          )}
          initialValue={type || InvoiceType.Individual}
          labelCol={{ span: 24 }}>
          <RadioGroup className={css.groupContainer}>
            <RadioItem className={css.item} value={InvoiceType.Individual}>
              {getI18n(
                `allOrders.orderDetail.component_customer_PersonalFapiao`,
              )}
            </RadioItem>
            <RadioItem className={css.item} value={InvoiceType.Company}>
              {getI18n(
                `allOrders.orderDetail.component_customer_BusinessFapiao`,
              )}
            </RadioItem>
          </RadioGroup>
        </Form.Item>
        <Form.Item
          name='email'
          label='Email*'
          rules={[
            {
              required: true,
              message: getI18n(
                'allOrders.createneworder.component_customer_editfapiaoinfo_emailRequire',
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Input size='large' />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.type !== currentValues.type
          }>
          {({ getFieldValue }) =>
            getFieldValue('type') === InvoiceType.Company && (
              <Fragment>
                <Form.Item
                  name='title'
                  label={getI18n(
                    `allOrders.orderDetail.component_customer_Fapiao_title`,
                  )}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'allOrders.createneworder.component_customer_editfapiaoinfo_fapiaorequire',
                      ),
                    },
                  ]}
                  labelCol={{ span: 24 }}>
                  <Input size='large' />
                </Form.Item>
                <Form.Item
                  name='tfn'
                  label={getI18n(
                    `allOrders.orderDetail.component_customer_Fapiao_taxFIleNum`,
                  )}
                  rules={[
                    {
                      required: true,
                      message: getI18n(
                        'allOrders.createneworder.component_customer_editfapiaoinfo_taxfilerequire',
                      ),
                    },
                  ]}
                  labelCol={{ span: 24 }}>
                  <Input size='large' />
                </Form.Item>
              </Fragment>
            )
          }
        </Form.Item>

        <Form.Item
          name='hasBeen'
          initialValue={hasBeen}
          label={getI18n(
            'allOrders.orderDetail.component_customer_editfapiaoinfo_fapiaostatus',
          )}
          labelCol={{ span: 24 }}>
          <OriCheckboxGroup
            className={css.groupContainer}
            options={hasBeenList}
          />
        </Form.Item>
        <Form.Item
          name='remarks'
          label={getI18n(
            'allOrders.orderDetail.component_customer_editfapiaoinfo_remarks',
          )}
          labelCol={{ span: 24 }}>
          <Input size='large' />
        </Form.Item>
      </Form>
      <ModalFooter
        onOk={() => formRef.submit()}
        okText={getI18n('general.confirm')}
        cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
        onCancel={() => {
          if (onPropsCancel) onPropsCancel();
          if (onDiscard) onDiscard();
        }}
        onDelete={() => onCancel()}
        deleteText={getI18n(
          'allOrders.createneworder.component_customer_editfapiaoinfo_cancelfapiao',
        )}
      />
    </Fragment>
  );
};

export default EditFapiaoInfo;
